<template>
  <a
    class="product-link-room"
    v-if="articleExists"
    :href="designerUrl"
    target="_blank"
  >
    Im Raum ansehen
  </a>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      articleExists: false,
      designerBaseUrl: 'https://ruckzuck-raumdesigner.aocluster.com',
      lastCheckedSku: null
    };
  },
  computed: {
    designerUrl() {
      return `${this.designerBaseUrl}/?art_nr=${this.product.raumdesigner_sku}`;
    }
  },
  watch: {
    'product.raumdesigner_sku': {
      immediate: true,
      handler(newSku, oldSku) {
        if (newSku && newSku !== this.lastCheckedSku) {
          this.lastCheckedSku = newSku;
          this.checkArticleExists(newSku);
        }
      }
    }
  },
  methods: {
    async checkArticleExists() {
      const baseUrl = 'https://designcenter-i.floor24.de/v2.1';
      const cnf = 'ruckzuck_int';
      const sku = this.product.raumdesigner_sku;

      if (!sku) {
        this.articleExists = false;
        return;
      }

      const url = `${baseUrl}/get_datalist_materials.php?cols=article_nr&cnf=${cnf}&skeys=article_nr&svals=${sku}`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();
        this.articleExists = parseInt(data.resultcnt) > 0;
      } catch (error) {
        console.error('Error fetching data:', error);
        this.articleExists = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-link-room {
  /* Add styles if needed */
}
</style>